"use strict";

const _ = require('lodash');
const d3 = require('d3');
const format = require('../lib/format');

class BasicAxis {
	constructor(scale, options) {
		this._scale = scale;
		this._options = Object.assign({ticks: 5, css: ''}, options);
		this.initAxis();
	}

	get scale() {
		return this._scale;
	}

	get options() {
		return this._options;
	}

	get axis() {
		return this._axis;
	}

	get selection() {
		return this._selection;
	}

	createAxis() {
		throw new TypeError('Not implemented');
	}

	initAxis() {
		this._axis = this.createAxis()
			.scale(this.scale).ticks(this.options.ticks)
			.tickFormat(_.partial(this.tickFormat, this));
		return this.axis;
	}

	tickFormat(self, tick) {
		return format(tick);
	}

	draw(selection) {
		let axis = this.initAxis();
		let {translate, css} = this.options;
		let s = this._selection = selection.append('g').classed(css, true).call(axis);
		if (translate) {
			s.attr('transform', 'translate(' + translate.join(',') + ')');
		}
		return s;
	}
}

class YAxis extends BasicAxis {
	constructor(scale, options) {
		super(scale, Object.assign({css: 'y axis', ticks: 4}, options));
	}

	createAxis() {
		return d3.axisRight();
	}

	initAxis() {
		return super.initAxis().tickSize(this.options.width);
	}

	tickFormat(self, tick) {
		return format(tick, {numberFormat: '0[.]0a'});
	}
}

class XAxis extends BasicAxis {
	constructor(scale, options) {
		super(scale, Object.assign({css: 'x axis'}, options));
	}

	createAxis() {
		return d3.axisBottom();
	}
}

module.exports = {BasicAxis: BasicAxis, YAxis: YAxis, XAxis: XAxis};
